
import fetch from '../../lib/wrappedFetch'
import config from '../../config'

class RemoteConfigService {
  fetchRemoteConfig = () => {
    return fetch(config.config.endpointUrls.fetchRemoteConfig(), {
      method: 'GET'
    })
  }
}

export default new RemoteConfigService()



// WEBPACK FOOTER //
// ../src/services/remoteConfigService/remoteConfigService.js